module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/store_images/5_678addfe3ff605ad4b7b6f587e1d8472.png";